/* Naht & Leinen – Team C: Warenkorb-Seite (<nl-warenkorb>) und „Passt dazu“ (Schublade + Seite).
   Baut auf Craft auf: CartItems (cart.js), CartDrawer.renderContents (cart-drawer.js), quantity-input (global.js). */
(function () {
  'use strict';

  function warenkorbUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function hinzufuegenUrl() {
    return ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
  }

  function innerVon(html, selektor) {
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selektor);
    return el ? el.innerHTML : null;
  }

  /* Schublade und Warenkorb-Symbol aus einer Antwort mit sections aktualisieren, ohne die Schublade zu öffnen */
  function schubladeAktualisieren(sections) {
    var schublade = document.querySelector('cart-drawer');
    if (schublade && sections['cart-drawer']) {
      var inhalt = innerVon(sections['cart-drawer'], '#CartDrawer');
      var ziel = document.getElementById('CartDrawer');
      if (inhalt !== null && ziel) {
        ziel.innerHTML = inhalt;
        schublade.classList.remove('is-empty');
        var overlay = document.getElementById('CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', schublade.close.bind(schublade));
      }
    }
    var blase = document.getElementById('cart-icon-bubble');
    if (blase && sections['cart-icon-bubble']) {
      var b = innerVon(sections['cart-icon-bubble'], '.shopify-section');
      if (b !== null) blase.innerHTML = b;
    }
  }

  /* „Passt dazu“: Formular abfangen und per Ajax in den Warenkorb legen */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-nl-passt-dazu]') || !window.fetch) return;
    e.preventDefault();
    var box = form.closest('.nl-shop-passt');
    var alterFehler = box && box.querySelector('.nl-shop-passt__fehler');
    if (alterFehler) alterFehler.remove();
    if (box) box.classList.add('is-laedt');

    var seite = document.querySelector('nl-warenkorb');
    var schublade = document.querySelector('cart-drawer');
    var inSchublade = !!form.closest('cart-drawer');
    var sections = [];
    if (seite && seite.dataset.section) sections.push(seite.dataset.section);
    if (schublade) sections.push('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) sections.push('cart-icon-bubble');

    fetch(hinzufuegenUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (antwort) {
        if (antwort.status || !antwort.sections) {
          throw new Error(antwort.description || antwort.message || 'Das hat leider nicht geklappt.');
        }
        if (seite && typeof seite.abschnitteSetzen === 'function') {
          seite.abschnitteSetzen(antwort.sections[seite.dataset.section]);
        }
        if (inSchublade && schublade && typeof schublade.renderContents === 'function') {
          schublade.renderContents(antwort);
        } else {
          schubladeAktualisieren(antwort.sections);
        }
      })
      .catch(function (fehler) {
        if (!box || !box.isConnected) return;
        box.classList.remove('is-laedt');
        var p = document.createElement('p');
        p.className = 'nl-shop-passt__fehler';
        p.setAttribute('role', 'alert');
        p.textContent = fehler && fehler.message ? fehler.message : 'Das hat leider nicht geklappt.';
        box.appendChild(p);
      });
  });

  /* Warenkorb-Seite: nutzt die Mengen-/Entfernen-Logik von Craft (CartItems), rendert aber die eigenen Bereiche neu */
  function definieren() {
    if (!window.customElements || customElements.get('nl-warenkorb') || typeof CartItems === 'undefined') return;

    var BEREICHE = ['NlWk-Kopf', 'main-cart-items', 'NlWk-Summe'];

    class NlWarenkorb extends CartItems {
      constructor() {
        super();
        this.addEventListener('click', (event) => {
          var knopf = event.target.closest('[data-nl-entfernen]');
          if (!knopf || !this.contains(knopf)) return;
          event.preventDefault();
          this.updateQuantity(knopf.dataset.index, 0, event);
        });
      }

      onChange(event) {
        /* Nur Mengenfelder auslösen lassen (Anmerkung, Formulare von Apps usw. nicht) */
        if (!event.target.classList || !event.target.classList.contains('quantity__input')) return;
        super.onChange(event);
      }

      getSectionsToRender() {
        var id = this.dataset.section;
        var liste = BEREICHE.map(function (bereich) {
          return { id: bereich, section: id, selector: '#' + bereich };
        });
        if (document.getElementById('CartDrawer')) {
          liste.push({ id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' });
        }
        if (document.getElementById('cart-icon-bubble')) {
          liste.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
        }
        return liste;
      }

      abschnitteSetzen(html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        BEREICHE.forEach(function (bereich) {
          var neu = doc.getElementById(bereich);
          var alt = document.getElementById(bereich);
          if (neu && alt) alt.innerHTML = neu.innerHTML;
        });
        var wurzel = doc.querySelector('nl-warenkorb');
        if (wurzel) this.classList.toggle('is-empty', wurzel.classList.contains('is-empty'));
      }

      onCartUpdate() {
        return fetch(warenkorbUrl() + '?section_id=' + encodeURIComponent(this.dataset.section))
          .then(function (r) { return r.text(); })
          .then((html) => this.abschnitteSetzen(html))
          .catch(function (fehler) { console.error(fehler); });
      }

      updateLiveRegions(line, message) {
        super.updateLiveRegions(line, message);
        var live = document.getElementById('cart-live-region-text');
        var summe = document.querySelector('#NlWk-Summe [data-nl-summe]');
        if (live) {
          live.textContent = message || ('Warenkorb aktualisiert.' + (summe ? ' Zwischensumme ' + summe.textContent.trim() + '.' : ''));
        }
      }
    }

    customElements.define('nl-warenkorb', NlWarenkorb);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', definieren);
  } else {
    definieren();
  }
})();
